
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eMrjW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Yx9c = parcelRequire("1Yx9c");


var $fnkyg = parcelRequire("fnkyg");

const $6d218f27e41db598$export$ba727134bfb13dd3 = ({ extensionNode: extensionNode, contentId: contentId, mode: mode })=>{
    const { parameters: parameters } = extensionNode || {};
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Yx9c.HubExtensionsWrapper), {
        mode: mode,
        extensionNode: extensionNode,
        contentId: contentId,
        showNoDataState: !parameters,
        packageName: "links-menu-extension",
        children: extensionNode && (0, $fnkyg.extensionHasParams)(extensionNode) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fnkyg.LinksMenuContent), {
            contentId: contentId,
            extensionNode: extensionNode,
            isInEditor: true
        }) : null
    });
};
const $6d218f27e41db598$export$f3053e92898af37 = ({ propsProvider: PropsProvider, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)(PropsProvider, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)($6d218f27e41db598$export$ba727134bfb13dd3, {
            ...props
        })
    });
module.exports["LinksMenuExtensionInner"] = $6d218f27e41db598$export$ba727134bfb13dd3;
module.exports["LinksMenuExtension"] = $6d218f27e41db598$export$f3053e92898af37;

});

parcelRegister("1Yx9c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");


var $fOKpq = parcelRequire("fOKpq");


var $4cOi8 = parcelRequire("4cOi8");


var $1m9A2 = parcelRequire("1m9A2");


var $8Ixq2 = parcelRequire("8Ixq2");


var $jrlgF = parcelRequire("jrlgF");


var $glqE9 = parcelRequire("glqE9");

const $b3bbb984d806269d$export$1b8348eac06ebe09 = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children, showNoDataState: showNoDataState, mode: mode = (0, $4cOi8.ExtensionMode).RENDERER, packageName: packageName })=>{
    const { analyticsContext: analyticsContext, errorBoundaryComponent: errorBoundaryComponent, experienceStartComponent: experienceStartComponent } = (0, $fOKpq.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode || {};
    const hasParameters = !showNoDataState || parameters;
    const ExperienceStart = experienceStartComponent || (0, $42omo.Fragment);
    const ErrorBoundaryComponent = errorBoundaryComponent || (0, $jrlgF.HubErrorBoundary);
    const errorBoundaryProps = errorBoundaryComponent ? {} : {
        id: extensionKey ?? contentId,
        packageName: packageName,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {})
    };
    (0, $42omo.useEffect)(()=>{
        if (mode === (0, $4cOi8.ExtensionMode).RENDERER) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    ...analyticsContext,
                    hasParameters: !!parameters,
                    contentId: contentId
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: extensionKey || 'unknown-hub-extension',
        children: /*#__PURE__*/ (0, $l998X.jsxs)(ErrorBoundaryComponent, {
            ...errorBoundaryProps,
            shouldForceError: (0, $glqE9.EXTENSIONS_CRITICAL_FOR_PAGE_LOAD).has(extensionKey || ''),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(ExperienceStart, {}),
                hasParameters ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $1m9A2.NoExtensionData), {
                    source: extensionKey
                })
            ]
        })
    });
};
module.exports["HubExtensionsWrapper"] = $b3bbb984d806269d$export$1b8348eac06ebe09;

});

parcelRegister("1m9A2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");


var $fOKpq = parcelRequire("fOKpq");


var $harUV = parcelRequire("harUV");


var $dE8aF = parcelRequire("dE8aF");

const $947dafb4b85c32e6$var$styles = {
    baseStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o",
    configPanelStyles: "_4t3i1vuk",
    extensionStyles: "_4t3i1osq"
};
const $947dafb4b85c32e6$export$dd91c9257a0f1cd4 = ({ source: source = '', isConfigPanel: isConfigPanel })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $42omo.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        submitError?.(new Error(errorMessage));
    }, [
        extensionSourceName,
        isConfigPanel,
        submitError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($947dafb4b85c32e6$var$styles.baseStyles, isConfigPanel ? $947dafb4b85c32e6$var$styles.configPanelStyles : $947dafb4b85c32e6$var$styles.extensionStyles),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
            header: intl.formatMessage((0, $dE8aF.messages).noDataStateHeaderText),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $dE8aF.messages).noDataStateDescription
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($harUV)))
        })
    });
};
module.exports["NoExtensionData"] = $947dafb4b85c32e6$export$dd91c9257a0f1cd4;

});

parcelRegister("harUV", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});

parcelRegister("dE8aF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8bb95c815845532f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noDataStateHeaderText: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
module.exports["messages"] = $8bb95c815845532f$export$defe85febe8b728c;

});

parcelRegister("glqE9", function(module, exports) {
// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here
const $97dcfab536b484ac$export$3617e2677e53ded6 = new Set([
    'links-menu',
    'cards',
    'spotlight',
    'carousel',
    'hub-section',
    'jsm-help'
]);
module.exports["EXTENSIONS_CRITICAL_FOR_PAGE_LOAD"] = $97dcfab536b484ac$export$3617e2677e53ded6;

});

parcelRegister("fnkyg", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $19TyP = parcelRequire("19TyP");


var $fOKpq = parcelRequire("fOKpq");


var $dEsCs = parcelRequire("dEsCs");

const $5867bcf44103f0d8$var$ALIGNMENT_MAP = {
    [(0, $dEsCs.ALIGNMENT).LEFT]: 'flex-start',
    [(0, $dEsCs.ALIGNMENT).CENTER]: 'center',
    [(0, $dEsCs.ALIGNMENT).RIGHT]: 'flex-end'
};
const $5867bcf44103f0d8$var$getBorder = (color)=>`${"var(--ds-border-width-selected, 2px)"} solid ${color}`;
const $5867bcf44103f0d8$var$getBorderStyles = (color)=>({
        [(0, $dEsCs.BORDER).NONE]: {},
        [(0, $dEsCs.BORDER).ALL_SIDES]: {
            border: $5867bcf44103f0d8$var$getBorder(color)
        },
        [(0, $dEsCs.BORDER).BOTTOM]: {
            borderBottom: $5867bcf44103f0d8$var$getBorder(color)
        }
    });
const $5867bcf44103f0d8$var$CORNERS_MAP = {
    [(0, $dEsCs.CORNERS).ROUND]: "var(--ds-radius-small, 4px)",
    [(0, $dEsCs.CORNERS).SHARP]: 'unset'
};
const $5867bcf44103f0d8$export$4a96f3bbfd95cbd4 = (styles)=>{
    const { alignment: alignment, fillColor: fillColor, borderColor: borderColor, border: border, cornerStyle: cornerStyle } = styles;
    return {
        justifyContent: $5867bcf44103f0d8$var$ALIGNMENT_MAP[alignment],
        backgroundColor: fillColor,
        ...$5867bcf44103f0d8$var$getBorderStyles(borderColor)[border],
        borderRadius: $5867bcf44103f0d8$var$CORNERS_MAP[cornerStyle]
    };
};









var $jSnXV = parcelRequire("jSnXV");


var $aXWIB = parcelRequire("aXWIB");


var $4JDbp = parcelRequire("4JDbp");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $4rwCt = parcelRequire("4rwCt");


var $inPa6 = parcelRequire("inPa6");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $fVUfS = parcelRequire("fVUfS");





var $cVaAA = parcelRequire("cVaAA");




const $a0bde112c8d9b5bb$var$triggerStyles = {
    firstItem: "_2rko12b0 _zulpu2gc _4cvr1h6o _bfhksm61 _1e0c1txw _irr31dpa",
    firstItemSelected: "_2rko12b0 _zulpu2gc _4cvr1h6o _bfhk1dpa _1e0c1txw",
    dropdownItem: "_bfhk1dpa"
};
const $a0bde112c8d9b5bb$var$selectedDropdownItemStyles = null;
const $a0bde112c8d9b5bb$var$displayTextStyles = null;
const $a0bde112c8d9b5bb$var$firstItemStyles = null;
const $a0bde112c8d9b5bb$var$NestedLinkItem = ({ childItemId: childItemId, childTitle: childTitle, link: link })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { useAnalyticsActions: useAnalyticsActions } = (0, $fOKpq.useProductDependencies)();
    const analytics = useAnalyticsActions?.useLinkAnalyticActions?.(link);
    (0, $42omo.useEffect)(()=>{
        analytics?.handleView?.();
    }, [
        analytics,
        analytics?.handleView
    ]);
    const handleLinkItemClick = ()=>{
        analytics?.handleClick?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link item',
                source: (0, $cVaAA.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE)
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        href: link,
        onClick: handleLinkItemClick,
        target: "_blank",
        children: childTitle
    }, childItemId);
};
const $a0bde112c8d9b5bb$export$2ce376c2cc3355c8 = ({ index: index, itemId: itemId, title: title, childItems: childItems, isFirstItem: isFirstItem, highlightColor: highlightColor, textColor: textColor, setWidth: setWidth })=>{
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (setWidth && ref.current) setWidth(ref.current.offsetWidth, index);
         // if item title updates, trigger a width recalculation
    }, [
        setWidth,
        index,
        title
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireUIAnalytic = ()=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'menu item',
                source: (0, $cVaAA.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE)
            }
        }).fire();
    return(// TODO: Add `shouldRenderToParent` to resolve accessibility issues. See https://a11y.atlassian.net/browse/JCATS-788
    /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        placement: isFirstItem ? 'bottom-start' : 'right-start',
        shouldFlip: !isFirstItem,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>isFirstItem ? /*#__PURE__*/ (0, $42omo.createElement)((0, $fVUfS.default), {
                ...triggerProps,
                key: itemId,
                ref: (0, $4rwCt.mergeRefs)([
                    triggerRef,
                    ref
                ]),
                xcss: triggerProps['aria-expanded'] ? $a0bde112c8d9b5bb$var$triggerStyles.firstItemSelected : $a0bde112c8d9b5bb$var$triggerStyles.firstItem,
                onClick: (e)=>{
                    triggerProps.onClick?.(e);
                    fireUIAnalytic();
                },
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("span" /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ , {
                        style: {
                            color: triggerProps['aria-expanded'] ? highlightColor : textColor
                        },
                        className: (0, $gMc0m.default)([
                            "_11c8fhey _k48p1wq8",
                            "_1reo15vq _18m915vq _1e0c1ule _p12fuuw1 _1bto1l2s _o5721q9c"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            color: triggerProps['aria-expanded'] ? highlightColor : textColor
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: "dropdown-expand",
                            size: "small"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1i071dpa _16c3n7od _1eq6glyw"
                ]),
                children: /*#__PURE__*/ (0, $42omo.createElement)((0, $dAYOx.default), {
                    ...triggerProps,
                    elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        label: "dropdown-expand",
                        size: "small"
                    }),
                    key: itemId,
                    ref: triggerRef,
                    onClick: (e)=>{
                        triggerProps.onClick?.(e);
                        fireUIAnalytic();
                    }
                }, /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_1reo15vq _18m915vq _1e0c1ule _p12fuuw1 _1bto1l2s _o5721q9c"
                    ]),
                    children: title
                }))
            }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
            children: childItems?.map((item)=>{
                const { itemId: childItemId, title: childTitle, type: type } = item;
                if (type === (0, $dEsCs.ITEM).MENU) return /*#__PURE__*/ (0, $l998X.jsx)($a0bde112c8d9b5bb$export$2ce376c2cc3355c8, {
                    title: childTitle,
                    childItems: item.childItems
                }, childItemId);
                const { link: link } = item;
                return /*#__PURE__*/ (0, $l998X.jsx)($a0bde112c8d9b5bb$var$NestedLinkItem, {
                    childItemId: childItemId,
                    childTitle: childTitle,
                    link: link
                }, childItemId);
            })
        })
    }));
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $7p4As = parcelRequire("7p4As");







const $f93bdb355452f7fb$export$68ef190193a37bc2 = ({ index: index, itemId: itemId, link: link, textColor: textColor, title: title, setWidth: setWidth })=>{
    const ref = (0, $42omo.useRef)(null);
    const { useAnalyticsActions: useAnalyticsActions } = (0, $fOKpq.useProductDependencies)();
    (0, $42omo.useLayoutEffect)(()=>{
        if (setWidth && ref.current) setWidth(ref.current.offsetWidth, index);
    // if item title updates, trigger a width recalculation
    }, [
        setWidth,
        index,
        title
    ]);
    const analytics = useAnalyticsActions?.useLinkAnalyticActions?.(link);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredView = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasFiredView.current && analytics?.handleView) {
            analytics.handleView();
            hasFiredView.current = true;
        }
    }, [
        analytics,
        analytics?.handleView
    ]);
    const handleLinkButtonClick = ()=>{
        analytics?.handleClick?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link item',
                source: (0, $cVaAA.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE)
            }
        }).fire();
    };
    const href = link || undefined;
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        appearance: "subtle",
        target: "_blank",
        href: href,
        id: itemId,
        ref: ref,
        onClick: handleLinkButtonClick,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ style: {
                color: textColor
            },
            children: title
        })
    }) : null;
};





const $76d27a5749026398$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    moreItemTitle: {
        id: "company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title",
        defaultMessage: "More"
    }
});


const $f350d7e3cc95a58a$var$APPROX_OVERFLOW_BUTTON_WIDTH = 100;
const $f350d7e3cc95a58a$var$APPROX_MIN_PADDING_INLINE = 48;
function $f350d7e3cc95a58a$var$howManyTabsFit(individualTabWidths, availableWidth) {
    let numberTabs = 0, totalWidthTabs = 0;
    for(let i = 0; i < individualTabWidths.length; i++){
        totalWidthTabs += individualTabWidths[i];
        if (totalWidthTabs > availableWidth) break;
        numberTabs++;
    }
    return {
        numberTabs: numberTabs
    };
}
const $f350d7e3cc95a58a$export$4501b8c967503aa = ({ highlightColor: highlightColor, items: items, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [maxLinksMenuTabs, setMaxLinksMenuTabs] = (0, $42omo.useState)(items?.length || 0);
    const itemTabWidths = (0, $42omo.useRef)([]);
    const [width, setWidth] = (0, $42omo.useState)(0);
    (0, $42omo.useLayoutEffect)(()=>{
        // calculate how many tabs fit given current width on first render, and on resize
        const availableWidth = Math.max(width - $f350d7e3cc95a58a$var$APPROX_OVERFLOW_BUTTON_WIDTH - 2 * $f350d7e3cc95a58a$var$APPROX_MIN_PADDING_INLINE, 0);
        if (availableWidth) {
            const { numberTabs: numberTabs } = $f350d7e3cc95a58a$var$howManyTabsFit(itemTabWidths.current, availableWidth);
            setMaxLinksMenuTabs(numberTabs);
        }
    // run this calculation also when maxLinksMenuTabs updates
    }, [
        itemTabWidths,
        width,
        maxLinksMenuTabs
    ]);
    (0, $42omo.useEffect)(()=>{
        // Handle when `items` updates, eg link or menu items are added or removed in config panel and
        // we need to recalculate width.
        // Reset itemTabWidths to empty when `items` updates so that we can calculate all widths from
        // scratch, otherwise adding/deleting items can cause the widths array to fall out of sync as
        // elements move indexes in the items array
        itemTabWidths.current = [];
        // Resetting max # of tabs here will cause a brief rendering of ALL tabs and they will all call the
        // setWidth callback and update itemTabWidths array with their respective widths.
        // A new value for maxLinksMenuTabs will also cause useLayoutEffect to rerun, recalculate available width,
        // and reset maxLinksMenuTabs again which will send tabs that can't fit to the overflow menu.
        setMaxLinksMenuTabs(items?.length || 0);
    }, [
        items
    ]);
    if (!items) return null;
    const handleSetWebItemTabWidth = (tabWidth, index)=>{
        itemTabWidths.current[index] = tabWidth;
    };
    const onResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(setWidth, 100, {
        leading: false
    });
    const isOverflowDetected = items.length > maxLinksMenuTabs;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            items?.slice(0, maxLinksMenuTabs).map((item, index)=>{
                const { itemId: itemId, type: type, title: title } = item;
                if (type === (0, $dEsCs.ITEM).MENU) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a0bde112c8d9b5bb$export$2ce376c2cc3355c8), {
                    index: index,
                    title: title,
                    childItems: item.childItems,
                    highlightColor: highlightColor,
                    textColor: textColor,
                    isFirstItem: true,
                    setWidth: handleSetWebItemTabWidth
                }, index);
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $f93bdb355452f7fb$export$68ef190193a37bc2), {
                    index: index,
                    itemId: itemId,
                    link: item.link,
                    textColor: textColor,
                    title: title,
                    setWidth: handleSetWebItemTabWidth
                }, index);
            }),
            isOverflowDetected && /*#__PURE__*/ (0, $l998X.jsx)((0, $a0bde112c8d9b5bb$export$2ce376c2cc3355c8), {
                title: formatMessage((0, $76d27a5749026398$export$defe85febe8b728c).moreItemTitle),
                childItems: items?.slice(maxLinksMenuTabs - items.length),
                highlightColor: highlightColor,
                textColor: textColor,
                isFirstItem: true
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: onResize
            })
        ]
    });
};


const $7ddb07b5cbda930b$export$9ffe29f134ccd6e9 = (extensionNode)=>{
    return !!extensionNode.parameters;
};
const $7ddb07b5cbda930b$var$defaultStyles = {
    itemsWrapper: "_zulpu2gc _18zroahv _1e0c11p5 _wij21bp4 _ca0qutpp _n3tdutpp _1bah1h6o _1ul953f4",
    editorStyles: "_19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66"
};
const $7ddb07b5cbda930b$export$ff088c0b70bd7288 = ({ extensionNode: extensionNode, isInEditor: isInEditor })=>{
    const { parameters: parameters } = extensionNode;
    const { items: items, styles: styles } = parameters;
    const { experienceSuccessComponent: experienceSuccessComponent, isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor, getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor } = (0, $19TyP.useDarkModeColors)(isSSRProductInDarkMode);
    const fillColor = getDarkModeCompatibleBackgroundColor(styles.fillColor);
    const textColor = getDarkModeCompatibleTextColor(styles.textColor);
    const highlightColor = getDarkModeCompatibleTextColor(styles.highlightColor);
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "links-menu-extension",
        style: (0, $5867bcf44103f0d8$export$4a96f3bbfd95cbd4)({
            ...styles,
            fillColor: fillColor
        }),
        className: (0, $gMc0m.default)([
            $7ddb07b5cbda930b$var$defaultStyles.itemsWrapper,
            isInEditor && $7ddb07b5cbda930b$var$defaultStyles.editorStyles
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f350d7e3cc95a58a$export$4501b8c967503aa), {
                highlightColor: highlightColor,
                items: items,
                textColor: textColor
            }),
            /*#__PURE__*/ (0, $l998X.jsx)(ExperienceSuccessComponent, {})
        ]
    });
};
module.exports["extensionHasParams"] = $7ddb07b5cbda930b$export$9ffe29f134ccd6e9;
module.exports["LinksMenuContent"] = $7ddb07b5cbda930b$export$ff088c0b70bd7288;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});


//# sourceMappingURL=links-menu-extension.e7acc1dd.js.map
